import { createContext } from 'react';

import { IUseCartContext } from 'components/logic/Cart/types/context-types';

export const CartContext = createContext<IUseCartContext>({
  cartItemsQuantityMap: new Map(),
  cartItems: [],
  minersData: [],
  cartListWithMinersData: [],
  cartId: 0,
  isTooltipOpen: false,
  isEmpty: true,
  cartItemsAllQuantity: 0,
  isCartPending: false,
  minersInCartLength: 0,
  isTrialMinerCheckout: false,
  trialMinersInCartLength: 0,
  handleTooltipOpen: () => {
    return;
  },
  handleTooltipClose: () => {
    return;
  },
  handleIncrement: () => {
    return;
  },
  handleDecrement: () => {
    return;
  },
  handleInputChange: () => {
    return;
  },
  handleDeleteAllSameItems: () => {
    return;
  },
  handleDeleteAllItems: () => {
    return;
  },
  handleCheckoutClick: () => {
    return;
  },
  handleTrialCheckoutClick: () => {
    return;
  },
  setIsTooltipOpen: () => {
    return;
  },
  handleItemInCart: () => {
    return false;
  },
  handleKeyDown: () => {
    return;
  },
  handleBlur: () => {
    return;
  },
  handleItemsMapClear: () => {
    return;
  },
  t: () => '',
});
